import { EMPTY_STRING } from "@/data/constants/marketing";
import { useClickAndCollect } from "@/data/Content/ClickAndCollect";
import { useLocationIQAutoComplete } from "@/data/Content/LocationIQ";
import { ContentContext } from "@/data/context/content";
import { useLocalization } from "@/data/Localization";
import { LatLng, StoreDetails, StoreSearchAutoCompleteOption } from "@/data/types/Store";
import { Search } from "@mui/icons-material";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import { debounce } from "lodash";
import { FC, useCallback, useContext, useEffect, useState } from "react";

type Porps = {
    setSelectedStores?:(storeDetails:StoreDetails[])=>void,
    latLngP?:LatLng
    setLatLngStoreStock?:(latLng:LatLng)=>void;
}

export const StoreStockAutoComplete:FC<Porps> = ({setSelectedStores, latLngP, setLatLngStoreStock }) => {

    const [searchKey, setSearchKey] = useState(EMPTY_STRING);
    const [finalSearchKey, setFinalSearchKey] = useState(EMPTY_STRING);
    const storeStockNLS = useLocalization('StoreStock');

    const {
        setLatLng,
        setDisplayStores,
    } = useContext(ContentContext) as ReturnType<typeof useClickAndCollect>;

    const {lqAutoCompleteOtions} = useLocationIQAutoComplete(finalSearchKey)

    useEffect(()=>{
        if(latLngP?.lat)setLatLng(latLngP)
    },[latLngP])

    const handleInputChnage = (e: unknown, v: string | StoreSearchAutoCompleteOption | null) => {
        if(e===null){
            setSearchKey("")
            setLatLng({} as LatLng);
            return false;
        }
        if (v && typeof v !== "string" && v.lat && v.lon) {
            let tempLatLng = {
                lat: parseFloat(v.lat),
                lng: parseFloat(v.lon)
            }
            setSearchKey(v.display_name)
            if(typeof setDisplayStores === 'function')setDisplayStores([]);
            if(typeof setLatLngStoreStock === 'function'){
                setLatLngStoreStock(tempLatLng);
            }else{
                setLatLng(tempLatLng);
            }
            if(typeof setSelectedStores === 'function')setSelectedStores([])
        }
    }

    useEffect(() => {
        if (searchKey.length > 2) {
            debouncedSeachInpChangeHandler(searchKey)
        } else {
            setFinalSearchKey(EMPTY_STRING);
        }
    }, [searchKey]);

    const debouncedSeachInpChangeHandler = useCallback(
        debounce((searchKey) => {
            setFinalSearchKey(searchKey);
        }, 400)
        , []);

    return(
            <Autocomplete
                id="store-stock-search"
                noOptionsText={storeStockNLS.noOptionsText.t()}
                fullWidth
                inputValue={searchKey}
                options={lqAutoCompleteOtions}
                disableClearable={true}
                autoHighlight
                selectOnFocus
                filterOptions={(options) => options}
                freeSolo
                popupIcon={<Search />}
                forcePopupIcon
                getOptionLabel={(option) => typeof option === 'string' ? option : option.place_id}
                isOptionEqualToValue={(option, value) => option.place_id === value.place_id}
                renderOption={(props, option) => {
                    const boldString = (str: string, substr: string) =>
                        substr.length > 2 ? str.replace(new RegExp(substr, 'ig'), '<b style="text-transform:capitalize">' + substr + '</b>') : str;
                    return (
                        <Box component="li"  {...props} px={2} py={0.5}>
                            <Box>
                                <Typography dangerouslySetInnerHTML={{ __html: boldString(option.address.name, searchKey) }} />
                                <Typography sx={{ fontSize: 12 }}>{option.address.state},{option.address.country}</Typography>
                            </Box>
                        </Box>
                    )
                }}
                sx={{
                    "& .MuiAutocomplete-popupIndicator": { transform: "none" },
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={storeStockNLS.FindAStore.t()}
                        placeholder={storeStockNLS.FindAStore.t()}
                        fullWidth
                        onChange={(event) => setSearchKey(event.target.value)}
                    />
                )}
                onFocus={() => setSearchKey(EMPTY_STRING)}
                onChange={(e, v) => handleInputChnage(e, v)}
            />
    );
}